import React from "react";
import CustomDrawer from "@/shared/components/ui/Drawer/CustomDrawer";
import ApolloFilters from "@/features/contacts/components/Apollo/ApolloFilters";
import { useMainStore } from "@/stores";
import { PROSPECT_DEFAULT_FILTERS, PROSPECT_FILTER_FIELDS } from "../../constants/prospectConfig";

// Trial imports are email only, so filtering by phone would promise numbers they can't get.
const TRIAL_PHONE_REASON = "Phone numbers are available on paid plans. Upgrade to search by phone.";

const CustomDrawerComponent = CustomDrawer as React.ComponentType<any>;
const ApolloFiltersComponent = ApolloFilters as React.ComponentType<any>;

interface ProspectFiltersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  filters: Record<string, any>;
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  appliedFilters: Record<string, any>;
  onApply: () => void;
  onClear: () => void;
  isApplying: boolean;
}

/** The same filter panel as the Contacts "Find Contacts" drawer, in a side panel. */
export default function ProspectFiltersDrawer({
  isOpen,
  onClose,
  filters,
  setFilters,
  appliedFilters,
  onApply,
  onClear,
  isApplying,
}: ProspectFiltersDrawerProps) {
  const isTrial = useMainStore((state: any) => state.user?.plan === "trial");
  const filterFields = React.useMemo(
    () =>
      isTrial
        ? PROSPECT_FILTER_FIELDS.map((f: any) => (f.key === "has_phone" ? { ...f, disabledReason: TRIAL_PHONE_REASON } : f))
        : PROSPECT_FILTER_FIELDS,
    [isTrial],
  );
  return (
    <CustomDrawerComponent isOpen={isOpen} onClose={onClose} direction="right" width="420px" backdropClassName="z-[9999]">
      <div className="h-full bg-white dark:bg-gray-900">
        <ApolloFiltersComponent
          filters={filters}
          setFilters={setFilters}
          appliedFilters={appliedFilters}
          clearFilters={onClear}
          onUpdate={onApply}
          applyBusy={isApplying}
          onClose={onClose}
          filterFields={filterFields}
          defaultFiltersSnapshot={PROSPECT_DEFAULT_FILTERS}
        />
      </div>
    </CustomDrawerComponent>
  );
}
